import { typoM } from 'pages/selections/styles';

export const popperStyles = {
  mainButton: {
    ...typoM,
    color: '#fff',
    background: '#4D6EF5',
    padding: '8px 12px',
    maxHeight: '36px',
    borderRadius: '8px',
    boxShadow: 'none !important',
    textTransform: 'capitalize',
    '&:hover': {
      background: '#4D6EF5',
      opacity: '0.8',
    },
  },
  popover: {
    '& .MuiPopover-paper': {
      marginTop: '8px',
      padding: '4px 0',
      borderRadius: '12px !important',
    },
    '& .MuiButtonBase-root': {
      ...typoM,
      textTransform: 'capitalize',
      display: 'block',
      padding: '14px 16px',
      minWidth: '174px',
      textAlign: 'left',
    },
  },
  iconBtn: {
    padding: 0,
    '&.with-border': {
      border: '1px solid #EDEFF7',
      borderRadius: '8px',
      width: '36px',
      height: '36px',
    },
    '&:hover': {
      background: '#fff',
    },
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  popperBtnOutlined: {
    ...typoM,
    textTransform: 'capitalize',
    background: '#fff',
    color: '#23252F',
    padding: '9px 14px',
    minWidth: '240px',
    border: '1px solid #F3F4F9',
    borderRadius: '12px',
    boxShadow: 'none',
    whiteSpace: 'nowrap',
    justifyContent: 'flex-start',
    '&:hover, &:active': {
      backgroundColor: '#f3f4f9',
      filter: 'drop-shadow(0px 0px 2px #4d6ef5)',
      boxShadow: 'none',
    },
  },
  customPopper: {
    marginTop: '4px !important',
    boxShadow: 'none',
  },
  actionBtn: {
    display: 'flex !important',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '8px',
    padding: '14px 16px',
    ...typoM,
    textTransform: 'capitalize',
    textDecoration: 'none',
    '& .MuiButton-startIcon': {
      margin: 0,
    },
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.04)',
    },
  },
};
